import React, { Component, Fragment } from "react";
import { Col } from "reactstrap";
import { themeService } from "../../../theme/service/activeTheme.service";
import { trackReportStyle } from "../Timps/style";
import { languageService } from "../../../Language/language.service";
import moment from "moment";
import DateRangeControl from "../../Common/DateRange/DateRangeControl";
import { CRUDFunction } from "../../../reduxCURD/container";
import { applyMiddleware } from "redux";
import WoReportsList from "./WoReportsList";
import SpinnerLoader from "../../Common/SpinnerLoader";
import OpenWorkOrderReport from "./OpenReport/OpenWorkOrderReport";
import { multiBorders } from "react-icons-kit/metrize/multiBorders";
import SvgIcon from "react-icons-kit";
import InputDateField from "../Timps/inputdateField";
import { SelectField } from "../Timps/reportfilter";
import { updateFilterState } from "reduxRelated/actions/filterStateAction";
import { UtilFunctions } from "./CommonUtilFunction";
import { versionInfo } from "../../MainPage/VersionInfo";
import { generalSortUsingArrayIndex } from "../../../utils/sortingMethods";
import { getReportSummary } from "../../../reduxRelated/actions/reportSummaryActions";
import { getAppMockupsTypes } from "../../../reduxRelated/actions/diagnosticsActions";
import permissionCheck from "../../../utils/permissionCheck";
import TooltipContainer from "../../../libraries/TooltipContainer";
import { PillTextButton } from "../../../libraries/GeneralButtons";
import { MaterialUsageCSVMethod } from "../../Maintenance/MaintenanceDetailPage/MaterialUsageCSV";
class WorkOrderReportModule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      year: new Date().getFullYear(),
      maintenanceList: [],
      filteredMaintenanceList: [],
      executions: {},
      spinnerLoading: false,
      openReport: {
        open: false,
        maintenances: [],
      },
      bulkPrint: false,
      dateRange: {
        from: new Date(moment().startOf("day")),
        today: new Date(),
        to: new Date(moment().endOf("day")),
      },
      InputObj: {
        location: "All",
        user: "All",
        assetType: "All",
        reportType: "Executions",
        priority: "All",
      },
      assetTypeOptions: [{ text: "All", val: "All" }],
      locationOptions: [{ text: "All", val: "All" }],
      userOptions: [{ text: "All", val: "All" }],
      priorityOptions: [{ text: "All", val: "All" }],
      reportTypeOptions: [
        { text: "Executions", val: "Executions" },
        { text: "Work Orders", val: "Maintenances" },
        // { text: "Daily Material Usage", val: "materialUsage" },
      ],
    };

    this.handleUpdateFilterState = this.handleUpdateFilterState.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleReportClose = this.handleReportClose.bind(this);
    this.handleBulkPrintClick = this.handleBulkPrintClick.bind(this);
    this.sortMaintenance = this.sortMaintenance.bind(this);
    this.updateDateRange = this.updateDateRange.bind(this);
    this.DropDownChangeHandler = this.DropDownChangeHandler.bind(this);
    this.setFilterValues = this.setFilterValues.bind(this);
    this.filterMaintenanceList = this.filterMaintenanceList.bind(this);
    this.resetInputFilters = this.resetInputFilters.bind(this);
    this.fetchWoReport = this.fetchWoReport.bind(this);
    this.getSummaryDataFromServer = this.getSummaryDataFromServer.bind(this);
  }

  componentDidMount() {
    const { dateRange } = this.state;
    dateRange && this.getRangeDataFromServer(dateRange);
    this.props.getAppMockupsTypes("materialTypes");
  }

  componentDidUpdate(prevProps, prevState) {
    const { work_order_reports, actionType } = this.props;
    if (
      (actionType != prevProps.actionType || this.props.priorityList !== prevProps.priorityList) &&
      actionType === "WORK_ORDER_REPORTS_READ_SUCCESS"
    ) {
      const StateToUpdate = {
        spinnerLoading: false,
      };
      if (work_order_reports.maintenanceList) {
        let sorted = this.sortMaintenance(work_order_reports.maintenanceList);
        const { userOptions, locationOptions, assetTypeOptions, priorityOptions } = this.setFilterValues(
          work_order_reports.maintenanceList,
        );
        StateToUpdate.userOptions = userOptions;
        StateToUpdate.locationOptions = locationOptions;
        StateToUpdate.maintenanceList = sorted;
        StateToUpdate.assetTypeOptions = assetTypeOptions;
        StateToUpdate.priorityOptions = priorityOptions;
        StateToUpdate.InputObj = { ...this.state.InputObj, ...this.resetInputFilters() };
      }
      if (work_order_reports.executions) {
        StateToUpdate.executions = work_order_reports.executions;
      }
      this.setState(StateToUpdate);
    }

    if (actionType != prevProps.actionType && actionType === "WORK_ORDER_REPORTS_READ_FAILURE") {
      this.setState({
        spinnerLoading: false,
      });
    }
    if (actionType != prevProps.actionType && actionType === "WORK_ORDER_REPORTS_READ_REQUEST") {
      this.setState({
        spinnerLoading: true,
      });
    }
    if (this.state.InputObj != prevState.InputObj && this.state.maintenanceList) {
      const FilteredM = this.filterMaintenanceList();
      this.setState({ filteredMaintenanceList: FilteredM });
    }
    if (this.state.maintenanceList != prevState.maintenanceList && this.state.maintenanceList) {
      this.setState({
        filteredMaintenanceList: this.filterMaintenanceList(),
      });
    }

    if (this.state.InputObj.reportType !== prevState.InputObj.reportType) {
      this.getRangeDataFromServer(this.state.dateRange, this.state.InputObj.reportType);
    }
    if (prevProps.reportSummaryActionType !== this.props.reportSummaryActionType) {
      if (this.props.reportSummaryActionType === "MATERIALUSAGECSV_GET_SUCCESS") {
        let range = this.state.dateRange;
        const formattedFromDate = moment(range.from).format("D MMM YY");
        const formattedToDate = moment(range.to).format("D MMM YY");

        let dateRange = `${formattedFromDate} - ${formattedToDate}`;
        dateRange = dateRange.toString();
        MaterialUsageCSVMethod(this.props.materialUsageCSVSummary, dateRange, this.props.materialTypes);
      }
    }
  }
  setFilterValues(maintenance) {
    let Locations = [{ text: "All", val: "All" }];
    let Users = [{ text: "All", val: "All" }];
    let Priority = [];
    const locationSet = new Set(["All"]);
    const userSet = new Set(["All"]);
    const assetTypeSet = new Set();
    const prioritySet = new Set(["All"]);

    maintenance.forEach((m) => {
      if (!locationSet.has(m.location)) {
        locationSet.add(m.location);
        Locations.push({ text: m.location, val: m.location });
      }

      let user = UtilFunctions.getLastInspectionUser(m);
      if (m.priority && !prioritySet.has(m.priority)) {
        prioritySet.add(m.priority);
        Priority.push({ text: m.priority, val: m.priority });
      }

      if (user && !userSet.has(user)) {
        userSet.add(user);
        Users.push({ text: user, val: user });
      }
      let assetType = m.issue && m.issue.unit && m.issue.unit.assetType;
      if (!assetTypeSet.has(assetType)) {
        assetTypeSet.add(assetType);
      }
    });

    let AssetTypes = Array.from(assetTypeSet)
      .sort()
      .map((assetType) => ({ text: assetType, val: assetType }));

    AssetTypes.unshift({ text: "All", val: "All" });

    Priority = Priority.sort((a, b) =>
      generalSortUsingArrayIndex(
        a.text,
        b.text,
        this.props.priorityList.map((l) => l.priority),
      ),
    );

    Priority.unshift({ text: "All", val: "All" });
    return {
      locationOptions: Locations,
      userOptions: Users,
      assetTypeOptions: AssetTypes,
      priorityOptions: Priority,
    };
  }
  resetInputFilters() {
    return {
      location: "All",
      user: "All",
      assetType: "All",
      priority: "All",
    };
  }
  handleRowClick(rowData) {
    this.fetchWoReport(rowData);
  }
  fetchWoReport(rowData) {
    const { InputObj } = this.state;
    const { executions, executionData } = rowData;
    let queryString =
      InputObj.reportType === "materialUsage" ? (executionData || []).map((e) => e._id).join(",") : (executions || []).join(",");
    let url = `executionsList/?executions=${queryString}`;
    this.props.getWork_order_reports(url);
    this.setState({
      openReport: {
        open: true,
        maintenances: [rowData],
      },
    });
  }
  handleReportClose() {
    this.setState({ openReport: { open: false, maintenances: [] } });
  }
  sortMaintenance(data) {
    let sortedArray = [];
    if (data && data.length > 0) {
      sortedArray = data.sort((a, b) => {
        const parseMR = (mr) => {
          if (typeof mr === "string" && mr.startsWith("MR#")) {
            const parsed = parseInt(mr.replace("MR#", ""), 10);
            return isNaN(parsed) ? 0 : parsed;
          }
          return 0;
        };

        const numA = parseMR(a.mrNumber);
        const numB = parseMR(b.mrNumber);

        return numB - numA;
      });
    }

    return sortedArray;
  }
  async handleBulkPrintClick() {
    const { filteredMaintenanceList } = this.state;
    let executionIds = [];
    filteredMaintenanceList.forEach((item) => {
      if (item.executions) {
        executionIds.push(...item.executions);
      }
    });

    let queryString = executionIds.join(",");
    let url = `executionsList/?executions=${queryString}`;
    this.setState({
      spinnerLoading: true,
    });
    await this.props.getWork_order_reports(url);
    this.setState({
      openReport: {
        open: true,
        maintenances: filteredMaintenanceList,
      },
      bulkPrint: true,
    });
  }
  getRangeDataFromServer(dateRange, rType) {
    let jsonArray = encodeURIComponent(JSON.stringify(dateRange));
    let args = "?dateRange=" + jsonArray + "&type=" + rType;
    this.props.getWork_order_reports(args);
  }
  handleUpdateFilterState(propertiesToUpdate) {
    //for State Retention
  }

  updateDateRange(dateRange) {
    this.setState({ dateRange: dateRange });
    // this.handleUpdateFilterState({ dateRange: dateRange });
    this.getRangeDataFromServer(dateRange, this.state.InputObj.reportType);
  }

  DropDownChangeHandler(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ InputObj: { ...this.state.InputObj, [name]: value } });
  }

  filterMaintenanceList() {
    const { maintenanceList, InputObj } = this.state;
    const { location, user, assetType, priority } = InputObj;
    let filteredList = [];
    if (maintenanceList && maintenanceList.length > 0) {
      filteredList = maintenanceList.filter((e) => {
        const usr = UtilFunctions.getLastInspectionUser(e) || "";

        const isUserValid = user === "All" || usr === user;
        const isLocationValid = location === "All" || e.location === location;
        const isValidPriority = priority === "All" || e.priority === priority;
        const isAssetValid =
          assetType === "All" || (e.issue && e.issue.unit && e.issue.unit.assetType && e.issue.unit.assetType === assetType);
        return isUserValid && isLocationValid && isAssetValid && isValidPriority;
      });
    }

    return this.sortMaintenance(filteredList);
  }
  getSummaryDataFromServer(range, location, user, report) {
    var jsonArray = encodeURIComponent(JSON.stringify(range));
    let reportName = report;
    let arg = "summary/?dateRange=" + jsonArray;

    arg = arg + "&name=" + reportName + "&lineId=" + location + "&userId=" + user;

    this.props.getReportSummary(arg, reportName);
  }

  render() {
    let spinner = <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />;
    const { openReport, executions, maintenanceList, InputObj } = this.state;
    return (
      <Fragment>
        {spinner}
        {!openReport.open && (
          <div className="mainContent" style={{ textAlign: "center" }}>
            <div
              style={{
                width: "100%",
                position: "relative",
              }}
            >
              {maintenanceList && maintenanceList.length > 0 && (
                <div
                  style={{
                    cursor: "pointer",
                    width: "fit-content",
                    display: "flex",
                    flexDirection: "column",
                    position: "absolute",
                    top: "15px",
                    right: "23px",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    this.handleBulkPrintClick();
                  }}
                >
                  <span style={{ fontSize: "12px" }}>{languageService("Bulk Print")}</span>
                  <SvgIcon size={32} icon={multiBorders} />
                </div>
              )}
              <div className="mainContent commonform" style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}>
                <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "none", fontSize: "22px" }}>
                  {languageService("Work Order Reports")}
                </h2>

                <div className="report-filter">
                  <label style={themeService(trackReportStyle.labelStyle)}>{languageService("Select a Date Range")}</label>
                  <span style={themeService(trackReportStyle.dateStyle)}>
                    <InputDateField
                      disabledDays={this.state.reportMinStartDate ? { before: new Date(this.state.reportMinStartDate) } : null}
                      minReportDate={this.state.reportMinStartDate}
                      updateDateRange={this.updateDateRange}
                      defaultDate={this.state.dateRange}
                    />
                  </span>
                  {this.state.locationOptions && this.state.locationOptions.length > 0 && (
                    <SelectField
                      inputFieldProps={{ name: "location", label: "Location" }}
                      options={this.state.locationOptions}
                      changeHandler={this.DropDownChangeHandler}
                      value={this.state.InputObj.location}
                    />
                  )}
                  {this.state.userOptions && this.state.userOptions.length > 0 && (
                    <SelectField
                      inputFieldProps={{ name: "user", label: "User" }}
                      options={this.state.userOptions}
                      changeHandler={this.DropDownChangeHandler}
                      value={this.state.InputObj.user}
                    />
                  )}
                  {this.state.assetTypeOptions && this.state.assetTypeOptions.length > 0 && (
                    <SelectField
                      inputFieldProps={{ name: "assetType", label: "Asset Type" }}
                      options={this.state.assetTypeOptions}
                      changeHandler={this.DropDownChangeHandler}
                      value={this.state.InputObj.assetType}
                    />
                  )}
                  {this.state.priorityOptions && this.state.priorityOptions.length > 0 && (
                    <SelectField
                      inputFieldProps={{ name: "priority", label: "Priority" }}
                      options={this.state.priorityOptions}
                      changeHandler={this.DropDownChangeHandler}
                      value={this.state.InputObj.priority}
                    />
                  )}

                  {!versionInfo.isReVAMP() && this.state.reportTypeOptions && this.state.reportTypeOptions.length > 0 && (
                    <SelectField
                      inputFieldProps={{ name: "reportType", label: languageService("Report Type") }}
                      options={this.state.reportTypeOptions}
                      changeHandler={this.DropDownChangeHandler}
                      value={this.state.InputObj.reportType}
                    />
                  )}
                </div>
              </div>
            </div>
            {InputObj.reportType === "materialUsage" && this.state.filteredMaintenanceList.length > 0 && (
              <Col
                md={11}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                {permissionCheck("MATERIAL USAGE REPORT SUMMARY", "view") && (
                  <TooltipContainer tooltipText={languageService("Work Order Material Usage Summary CSV")}>
                    <PillTextButton
                      title={languageService("W/O MT Usage Summary CSV")}
                      onClick={(e) => {
                        this.getSummaryDataFromServer(
                          this.state.dateRange,
                          this.state.InputObj.location,
                          this.state.InputObj.user,
                          "materialUsageCSV",
                        );
                      }}
                      style={{ fontSize: "12px", width: "max-content" }}
                    />
                  </TooltipContainer>
                )}
              </Col>
            )}
            <WoReportsList
              handleClick={this.handleRowClick}
              mList={this.state.filteredMaintenanceList}
              priorityList={this.props.priorityList}
            />
          </div>
        )}
        <OpenWorkOrderReport
          openReport={openReport}
          executions={executions}
          handleReportClose={this.handleReportClose}
          reportType={InputObj.reportType}
          materialTypes={this.props.materialTypes}
        />
      </Fragment>
    );
  }
}
let variables = {
  filterStateReducer: {
    workOrderReportFilter: null,
  },
  reportSummaryReducer: {
    materialUsageCSVSummary: [],
  },
  diagnosticsReducer: {
    materialTypes: [],
  },
};
let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: {
    updateFilterState,
    getReportSummary,
    getAppMockupsTypes,
  },
};
const WorkOrderReportModuleContainer = CRUDFunction(
  WorkOrderReportModule,
  "work_order_reports",
  actionOptions,
  variables,
  ["filterStateReducer", "reportSummaryReducer", "diagnosticsReducer"],
  "maintenance/workOrderReport",
);

export default WorkOrderReportModuleContainer;



// WEBPACK FOOTER //
// ./src/components/Reports/WorkOrderReport/Index.jsx